__turbopack_context__.v({
  "className": "j7QSha_className",
  "variable": "j7QSha_variable",
});
